<template>
    <div :style="divStyle">
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Tabs>
            <TabPane label="安装记录" name="fix">
                <fixRecord ref="fixRecord" />
            </TabPane>
            <TabPane label="安检记录" name="check">
                <checkRecord ref="checkRecord" />
            </TabPane>
            <TabPane label="维修记录" name="repair">
                <repairRecord ref="repairRecord" />
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
    import fixRecord from "./expand/OrderListFix.vue";
    import checkRecord from "./expand/OrderListCheck.vue";
    import repairRecord from "./expand/OrderListRepair.vue";
    export default {
        name: "order_list",
        computed: {
            divStyle() {
                var style = {};
                if(this.$parent.$refs.mainContent){
                    style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
                }else{
                    style.width = window.innerWidth - 279 + "px";
                }
                //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
                return style;
            }
        },
        components: {
            fixRecord,
            checkRecord,
            repairRecord
        },
        mounted() {
            var that = this;
            $.ajax({
                url: "/api/getAddressTree",
                contentType: "application/json",
                type: "get",
                dataType: "json",
                success: function(data) {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }
                    that.$refs.fixRecord.addressData = data.body[0].children;
                    that.$refs.checkRecord.addressData = data.body[0].children;
                    that.$refs.repairRecord.addressData = data.body[0].children;
                },
                error: function(textStatus) {
                    that.$Notice.error({
                        title: "异常",
                        desc: "接口请求异常"
                    });
                },
                complete: function() {}
            });
        },
        data() {
            return {
                isSpinShow: false
            }
        },
        methods: {
            spinShow(param) {
                this.isSpinShow = param;
            }
        }
    }
</script>

<style>
</style>
